<template>
    <div class="flash w-full flash-message ease-out fade" :class="flashType" role="alert">
        <div class="flex">
            <div class="py-1"><svg class="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
            <div style="width: calc(100% - 30px)">
                <p v-if="flashType === 'success'" class="font-bold">Großartig!</p>
                <p v-else-if="flashType === 'warning'" class="font-bold">Achtung:</p>
                <p v-else-if="flashType === 'error'" class="font-bold">Fehler:</p>
                <p v-else-if="flashType === 'info'" class="font-bold">Info:</p>
                <p class="text-sm" v-html="flashMessage"></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "flash",
        props: ['flashType', 'flashMessage'],
    }
</script>

<style lang="scss" scoped>
    .flash {
        @apply border-t-4 rounded-b px-4 py-3 shadow-md;
        &.success {
            @apply bg-teal-100 border-teal-500 text-teal-900;
        }
        &.warning {
            @apply bg-orange-100 border-orange-500 text-orange-900;
        }
        &.error {
            @apply bg-red-100 border-red-500 text-red-900;
        }
        &.info {
            @apply bg-blue-100 border-blue-500 text-blue-900;
        }
    }
</style>
